import React from "react";


interface PermutaServiceProps {
    icon: string,
    title: string,
    description: string,
}

const PermutaService = ({icon, title, description}:PermutaServiceProps) => {
    return (
        <div className="flex items-start justify-center max-lg:justify-start  space-x-3">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                <img src={icon} alt={title} />
            </div>
            <div className="max-w-[65%]">
                <h3 className="text-[14px] font-semibold">{title}</h3>
                <p className="text-[12px] text-gray-500">{description}</p>
            </div>
        </div>
    );
}

export default PermutaService;
